import Vue from 'vue';
import Vuex from 'vuex';
import tokenDecoder from 'jwt-decode';
import createPersistedState from 'vuex-persistedstate';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    user: {
      accToken: null,
      accTokenExp: null,
      usrUID: '',
    },
    language: 'kr',
    popupData: [],
    page: {
      store: 0,
      news: 0,
    },
    adminPage: {
      history: [0, 'kr'],
      beer: [0],
      news: [0, 'kr', 0],
      store: [0, 'kr', 0],
      contact: [0, 'all'],
    },
  },
  getters: {
    popup(state) {
      return state.popupData;
    },
    userInfo(state) {
      return state.user;
    },
    userAccTokenExp: state => {
      return state.user.accTokenExp;
    },
    userAccToken: state => {
      return state.user.accToken;
    },
    userUID: state => {
      return state.user.usrUID;
    },
    lan(state) {
      return state.language;
    },
    checkPage(state) {
      return state.page;
    },
    storePage: state => {
      return state.page.store;
    },
    newsPage: state => {
      return state.page.news;
    },
    checkAdminPage(state) {
      return state.adminPage;
    },
  },
  mutations: {
    async setToken(state, payload) {
      Object.keys(payload).forEach(val => {
        state.user[val] = payload[val];
      });
    },
    resetStore(state) {
      Object.keys(state.user).forEach(val => {
        Vue.set(state.user, val, null);
      });
    },
    async setLang(state, payload) {
      state.language = payload;
    },
    updatePopup(state, payload) {
      let idx = payload.idx;
      let data = payload;
      delete data.idx;
      let cat = Object.keys(data);
      cat.forEach(e => {
        state.popupData[idx][e] = payload[e];
      });
    },
    setPageHome(state, payload) {
      state.page[payload[0]] = payload[1];
    },
    delPage(state, payload) {
      state.adminPage = {
        history: [0, 'kr'],
        beer: [0],
        news: [0, 'kr', 0],
        store: [0, 'kr', 0],
        contact: [0, 'all'],
      };
    },
    savePageAdmin(state, payload) {
      if (payload.page !== undefined) {
        state.adminPage[payload.name][0] = payload.page;
      }
      if (payload.nation !== undefined) {
        state.adminPage[payload.name][1] = payload.nation;
      }
      if (payload.category !== undefined) {
        state.adminPage[payload.name][2] = payload.category;
      }
    },
    setPopup(state, payload) {
      if (payload.length > 0) {
        state.popupData = state.popupData.concat(payload);
      }
    },
    removePopup(state, payload) {
      state.popupData.forEach((e, i) => {
        if (payload.includes(e.idx)) {
          state.popupData.splice(i, 1);
        }
      });
    },
    initPopup(state, payload) {
      state.popupData[payload].neverShow = true;
      state.popupData[payload].neverTime = '';
    },
  },
  actions: {
    saveToken({ commit }, payload) {
      return new Promise(resolve => {
        let $_save = {};
        if (payload === null) {
          $_save.accToken = null;
          $_save.accTokenExp = null;
          $_save.usrUID = null;
        } else if (payload.status === 200) {
          let $_res = payload.data.res;
          if ('token' in $_res) {
            let $_accToken = $_res.token;
            let $_decodedAccToken = tokenDecoder($_accToken);

            $_save.accToken = $_accToken;
            $_save.accTokenExp = $_decodedAccToken.exp * 1000;
            $_save.usrUID = $_decodedAccToken.sub;
          }
        }

        commit('setToken', $_save);
        resolve(payload);
      });
    },
    getPopup({ commit }, payload) {
      return new Promise(resolve => {
        let addData = [];
        if (payload.status === 200) {
          let $_res = payload.data.res;
          let $_popup = this.getters.popup;

          let idxArr = [];
          for (var row of $_popup) {
            idxArr.push(row.idx);
          }

          // NOTE: 없는 idx의 popup을 추가
          for (var data of $_res) {
            if (!idxArr.includes(data.idx)) {
              let temp = data;
              temp.neverTime = '';
              temp.neverShow = true;
              addData.push(temp);
            }
          }
        }
        commit('setPopup', addData);
        resolve(payload);
      });
    },
    delPopup({ commit }, payload) {
      return new Promise(resolve => {
        let delIdx = [];
        if (payload.status === 200) {
          let $_res = payload.data.res;
          let $_popup = this.getters.popup;

          let idxArr = [];
          for (var data of $_res) {
            idxArr.push(data.idx);
          }

          // NOTE: 활성화 중이 아닌 팝업 데이터를 가지고 있을 경우 해당 idx 보냄
          for (var row of $_popup) {
            if (!idxArr.includes(row.idx)) {
              delIdx.push(row.idx);
            }
          }
        }
        commit('removePopup', delIdx);
        resolve(payload);
      });
    },
    neverTimeReset({ commit }, payload) {
      commit('initPopup', payload);
    },
    editPopup({ commit }, payload) {
      // NOTE: 값을 변경할 객체의 idx 값으로 배열의 인덱스 값을 찾아 mutation으로 넘김
      let $_payload = payload;
      let $_popup = this.getters.popup;
      let index = $_popup.findIndex(i => i.idx == payload.idx);
      $_payload.idx = index;

      commit('updatePopup', $_payload);
    },
    comparePopup({ commit }, payload) {
      return new Promise(resolve => {
        if (payload.status === 200) {
          let $_res = payload.data.res;
          let $_popup = this.getters.popup;

          // NOTE: 수정 된 내용 확인 위한 데이터 재정렬 => {idx: [device, title, img], ...}
          let existPopup = {};
          $_popup.forEach((e, i) => {
            let dataArr = [];
            dataArr[0] = e.device;
            dataArr[1] = e.title;
            dataArr[2] = e.img;
            existPopup[i] = dataArr;
          });

          let newPopup = {};
          $_res.forEach((e, i) => {
            let dataArr = [];
            dataArr[0] = e.device;
            dataArr[1] = e.title;
            dataArr[2] = e.img;
            newPopup[i] = dataArr;
          });

          // NOTE: 수정된 팝업 내용을 state의 popup에 반영
          let revisedPopup = [];
          for (var idx in existPopup) {
            let dataObj = {};
            if (
              JSON.stringify(existPopup[idx]) !== JSON.stringify(newPopup[idx])
            ) {
              existPopup[idx] = newPopup[idx];
              dataObj.idx = idx;
              dataObj.device = existPopup[idx][0];
              dataObj.title = existPopup[idx][1];
              dataObj.img = existPopup[idx][2];
              revisedPopup.push(dataObj);
            }
          }

          revisedPopup.forEach((e, i) => {
            commit('updatePopup', e);
          });
        }
        resolve(payload);
      });
    },
    getLang({ commit }, payload) {
      commit('setLang', payload);
    },
    savePage({ commit }, payload) {
      // NOTE: Home에서 사용
      commit('setPageHome', payload);
    },
    setPage({ commit }, payload) {
      // NOTE: Admin에서 사용
      commit('savePageAdmin', payload);
    },
    resetPage({ commit }, payload) {
      commit('delPage', payload);
    },
  },
  plugins: [
    createPersistedState({
      key: 'vuex',
      storage: {
        getItem: key => localStorage.getItem(key),
        setItem: (key, value) => localStorage.setItem(key, value),
        removeItem: key => localStorage.removeItem(key),
      },
    }),
  ],
});
